import React from 'react';
import { Link } from 'react-router-dom';
import { 
  getLogo, 
  getShortName, 
  getEmail, 
  getPhone, 
  getPhoneLink, 
  getAddress, 
  getSocialMedia, 
  getServices,
  getLegalInfo 
} from '../../data/companyDetails';

const Footer = () => {
  const logo = getLogo();
  const shortName = getShortName();
  const email = getEmail();
  const phone = getPhone();
  const phoneLink = getPhoneLink();
  const address = getAddress();
  const socialMedia = getSocialMedia();
  const services = getServices();
  const legal = getLegalInfo();

  return (
    <footer className="bg-dark text-white py-5" id="footer">
      <div className="container py-5">
        <div className="row g-5">
          {/* Company Info */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-section">
              <div className="d-flex align-items-center mb-4">
                <img src={logo.src} alt={logo.alt} height={40} width={40} className="me-2"/>
                <h4 className="fw-bold text-white mb-0">{shortName}</h4>
              </div>
              <p className="text-light mb-4">
                MastiShorts is India's favorite platform for live streaming and short video creation — made for creators, entertainers, and everyday fun.
              </p>
              
              {/* Newsletter Subscription */}
              <div className="mb-4">
                <h6 className="fw-bold mb-3 text-white">Stay Updated</h6>
                <div className="input-group">
                  <input 
                    type="email" 
                    className="form-control form-control-lg bg-dark border-secondary text-white" 
                    placeholder="Enter your email"
                    style={{borderRadius: '50px 0 0 50px'}}
                  />
                  <button 
                    className="btn btn-primary px-4" 
                    type="button"
                    style={{borderRadius: '0 50px 50px 0'}}
                  >
                    Subscribe
                  </button>
                </div>
              </div>
              
              {/* Social Media Icons */}
              {/* <div className="d-flex gap-3">
                <a href={socialMedia.facebook} className="text-white hover-primary">
                  <div className="bg-primary bg-opacity-20 rounded-circle p-2 d-inline-flex align-items-center justify-content-center" style={{width: '40px', height: '40px'}}>
                    <i className="fab fa-facebook-f"></i>
                  </div>
                </a>
                <a href={socialMedia.twitter} className="text-white hover-primary">
                  <div className="bg-info bg-opacity-20 rounded-circle p-2 d-inline-flex align-items-center justify-content-center" style={{width: '40px', height: '40px'}}>
                    <i className="fab fa-twitter"></i>
                  </div>
                </a>
                <a href={socialMedia.instagram} className="text-white hover-primary">
                  <div className="bg-danger bg-opacity-20 rounded-circle p-2 d-inline-flex align-items-center justify-content-center" style={{width: '40px', height: '40px'}}>
                    <i className="fab fa-instagram"></i>
                  </div>
                </a>
                <a href={socialMedia.linkedin} className="text-white hover-primary">
                  <div className="bg-primary bg-opacity-20 rounded-circle p-2 d-inline-flex align-items-center justify-content-center" style={{width: '40px', height: '40px'}}>
                    <i className="fab fa-linkedin-in"></i>
                  </div>
                </a>
              </div> */}
            </div>
          </div>
          
          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <div className="footer-section">
              <h5 className="fw-bold mb-4 text-white">
                <i className="fas fa-link text-primary me-2"></i>
                Quick Links
              </h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link to="/about" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-chevron-right text-primary me-2 small"></i>
                    About Us
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/contact" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-chevron-right text-primary me-2 small"></i>
                    Contact Us
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/privacy" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-chevron-right text-primary me-2 small"></i>
                    Privacy Policy
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/terms" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-chevron-right text-primary me-2 small"></i>
                    Terms & Conditions
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/refund" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-chevron-right text-primary me-2 small"></i>
                    Refund Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Services */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-section">
              <h5 className="fw-bold mb-4 text-white">
                <i className="fas fa-cogs text-success me-2"></i>
                Our Services
              </h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#services" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-video text-success me-2 small"></i>
                    Live Streaming
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#services" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-play-circle text-success me-2 small"></i>
                    Short Videos
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#services" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-gift text-success me-2 small"></i>
                    Virtual Gifts
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#services" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-trophy text-success me-2 small"></i>
                    PK Battles
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#services" className="text-light text-decoration-none hover-primary">
                    <i className="fas fa-users text-success me-2 small"></i>
                    Community
                  </a>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Contact Info */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-section">
              <h5 className="fw-bold mb-4 text-white">
                <i className="fas fa-address-book text-warning me-2"></i>
                Contact Info
              </h5>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-map-marker-alt text-warning me-3 mt-1"></i>
                    <span className="text-light small">{address}</span>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-envelope text-warning me-3"></i>
                    <a href={`mailto:${email}`} className="text-light text-decoration-none hover-primary small">
                      {email}
                    </a>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-phone text-warning me-3"></i>
                    <a href={phoneLink} className="text-light text-decoration-none hover-primary small">
                      {phone}
                    </a>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-globe text-warning me-3"></i>
                    <a href={`mailto:${email}`} className="text-light text-decoration-none hover-primary small">
                      {email}
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      {/* Copyright Section */}
      <div className="container">
        <hr className="border-secondary mb-4" />
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start">
            <p className="text-light mb-0">
              <i className="fas fa-copyright me-1"></i>
              {legal.copyrightText}
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <p className="text-light mb-0 small">
              Made with <i className="fas fa-heart text-danger"></i> in India
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
